import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Turborepo가 Vercel에 합류합니다",
  "description": "Turborepo가 Vercel에 합류하여 웹을 더욱 빠르게 만듭니다.",
  "date": "2021/12/09",
  "tag": "web development",
  "ogImage": "/images/blog/joining-vercel/x-card.png"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo가 Vercel에 인수되었으며 Turborepo CLI가 이제 오픈소스가 되었습니다! 또한 Turborepo는 이제 Vercel을 통해 설정 불필요 원격 캐싱을 제공합니다!"
  }, {
    "heading": "",
    "content": "beta.turborepo.com과 해당 원격 캐싱 서비스는 2022년 1월 15일에 종료되며, 이전 버전의 turbo CLI는 설치할 수 없게 됩니다."
  }, {
    "heading": "",
    "content": "이것은 프로젝트와 Turborepo를 지원하고 채택해 주신 모든 분들에게 중요한 순간입니다. Vercel의 인프라와 팀 지원으로 Turborepo의 기능을 확장하고 세계적 수준의 빌드 시스템을 개선하는 데 집중하는 팀을 구축하겠습니다. 이 새로운 장에 여러분을 모시기를 기대합니다."
  }, {
    "heading": "",
    "content": "12월 10일 금요일 오후 4시(미국 동부 표준시) | 오후 9시(영국 그리니치 표준시) 라이브 스트림 Q&A에 Vercel의 개발자 관계 책임자인 Lee Robinson과 함께 참여해 주세요. Turborepo와 Vercel이 함께 개발자 경험을 개선하기 위해 노력하는 동안 무엇이 준비되어 있는지 살펴보겠습니다."
  }, {
    "heading": "",
    "content": "이것은 시작일 뿐입니다. 우리는 더욱 빠른 빌드, 더욱 많은 유연성, 더욱 나은 워크플로의 세계로 나아가려고 합니다. 이 놀라운 여정에 함께해 주셔서 감사합니다."
  }],
  "headings": []
};
import {Authors} from '#components/authors';
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    p: "p",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx("h1", {
      className: "text-center",
      children: "Turborepo가 Vercel에 합류합니다"
    }), "\n", "\n", _jsx(Authors, {
      authors: ['jaredpalmer']
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo가 Vercel에 인수되었으며 Turborepo CLI가 이제 오픈소스가 되었습니다! 또한 Turborepo는 이제 ", _jsx(_components.a, {
        href: "https://vercel.com/?utm_source=turborepo.com&utm_medium=referral&utm_campaign=docs-link",
        children: "Vercel"
      }), "을 통해 설정 불필요 원격 캐싱을 제공합니다!"]
    }), "\n", _jsxs(_components.p, {
      children: ["beta.turborepo.com과 해당 원격 캐싱 서비스는 2022년 1월 15일에 종료되며, 이전 버전의 ", _jsx(_components.code, {
        children: "turbo"
      }), " CLI는 설치할 수 없게 됩니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["이것은 프로젝트와 Turborepo를 지원하고 채택해 주신 모든 분들에게 중요한 순간입니다. Vercel의 인프라와 팀 지원으로 Turborepo의 기능을 확장하고 세계적 수준의 빌드 시스템을 개선하는 데 집중하는 팀을 구축하겠습니다. 이 ", _jsx(_components.a, {
        href: "https://vercel.com/blog/vercel-acquires-turborepo",
        children: "새로운 장"
      }), "에 여러분을 모시기를 기대합니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://www.youtube.com/watch?v=YX5yoApjI3M",
        children: "12월 10일 금요일 오후 4시(미국 동부 표준시) | 오후 9시(영국 그리니치 표준시) 라이브 스트림 Q&A"
      }), "에 Vercel의 개발자 관계 책임자인 Lee Robinson과 함께 참여해 주세요. Turborepo와 Vercel이 함께 개발자 경험을 개선하기 위해 노력하는 동안 무엇이 준비되어 있는지 살펴보겠습니다."]
    }), "\n", _jsx(_components.p, {
      children: "이것은 시작일 뿐입니다. 우리는 더욱 빠른 빌드, 더욱 많은 유연성, 더욱 나은 워크플로의 세계로 나아가려고 합니다. 이 놀라운 여정에 함께해 주셔서 감사합니다."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
